import { SoapNoteGenerationStatus } from "~/providers/utils/types/zoomMeetingTypes";

export const SOAP_NOTE_GENERATION_STATUS = {
  pending: "PENDING",
  in_progress: "IN_PROGRESS",
  completed: "COMPLETED",
  failed: "FAILED",
} as const;

export const soapNoteGenerationStatusMessages: Record<
  SoapNoteGenerationStatus,
  string
> = {
  PENDING: "SOAP note is being generated. This may take a few minutes.",
  IN_PROGRESS: "SOAP note is being generated. This may take a few minutes.",
  COMPLETED: "",
  FAILED:
    "SOAP note generation failed. You can complete the note manually below.",
};
